module.exports = __webpack_public_path__ + "static/fireplace-f80e5e2943054fb1a53f8c132d7316ec.jpg";